var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteRightArrowExtended(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 8,
    viewBox: "0 0 27 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0537 4.35355C26.249 4.15829 26.249 3.84171 26.0537 3.64645L22.8718 0.464466C22.6765 0.269204 22.3599 0.269204 22.1647 0.464466C21.9694 0.659728 21.9694 0.976311 22.1647 1.17157L24.9931 4L22.1647 6.82843C21.9694 7.02369 21.9694 7.34027 22.1647 7.53553C22.3599 7.7308 22.6765 7.7308 22.8718 7.53553L26.0537 4.35355ZM0.200195 4.5H25.7002V3.5H0.200195V4.5Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteRightArrowExtended);
export default __webpack_public_path__ + "static/media/white-right-arrow-extended.8021e40fb9319b6aa87f242fe4b2174d.svg";
export { ForwardRef as ReactComponent };